import { PreorderSpan } from "../shop-layouts/shared/PreorderSpan";

import { css } from "@emotion/react";
import { getRibbonText } from "./PDP_SingleImageCarousel/getRibbonText";
import type { ProductVariantAvailabilityStatus } from "@swo/shared";
import { usePdpTranslations } from "./PdpTranslationsContext";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

const HAS_RIBBONS_ENABLED = false;

export const RibbonTextElement: React.FC<{
  availability: ProductVariantAvailabilityStatus | null;
}> = ({ availability }) => {
  const t = usePdpTranslations();

  const ribbonText: TranslatedValue | null = availability ? getRibbonText(availability, t) : null;

  return ribbonText && HAS_RIBBONS_ENABLED ? (
    <div
      css={css`
        top: 0;

        position: absolute;
        left: 0;
        margin-top: 12px;
        pointer-events: none;
      `}
    >
      <PreorderSpan>
        <T>{ribbonText}</T>
      </PreorderSpan>
    </div>
  ) : null;
};
